import { useTranslation } from 'next-i18next';
import { FAQByLocale } from '../../../types/Faq';
import FAQAccordion from './FAQAccordion';

type Props = {
  hotelId?: string;
  faqs: FAQByLocale[];
};

const FAQs = ({ hotelId, faqs }: Props) => {
  const { t } = useTranslation('hotel');

  return (
    <div className="scroll-mt-8">
      <p className="pb-3 text-title3 font-bold">{t('hotel:faq.title')}</p>
      {faqs.map((faq: FAQByLocale) => (
        <div key={faq.id} className="border-b text-gray-200">
          <FAQAccordion hotelId={hotelId} faq={faq} />
        </div>
      ))}
    </div>
  );
};

export default FAQs;
